<template>
  <div>
    <div class="artshare_top_bar">
      <span class="artshare_tip artshare_tip_noac" @click="goTome"
        >个人中心</span
      >
      <i class="el-icon-arrow-right"></i>
      <span class="artshare_tip artshare_tip_noac" @click="artmag"
        >文章管理</span
      >
      <i class="el-icon-arrow-right"></i>
      <span class="artshare_tip artshare_tip_noac">文章搜索</span>
      <i class="el-icon-arrow-right"></i>
      <span class="artshare_tip artshare_tip_noac">文章详情</span>
      <i class="el-icon-arrow-right"></i>
      <span class="artshare_tip">文章分享</span>
    </div>

    <div class="artshare_con">
      <div class="friend_item" v-for="item in friList">
        <el-radio v-model="radio"></el-radio>
        <img class="fri_img" src="../assets/face.jpg" />
        <span class="friend_name">陈志朋</span>
      </div>
    </div>

    <div class="artshare_btns_con">
      <button class="artshare_share_btn">分 享</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "artshare",
  data() {
    return {
      friList: [1, 2, 3],
      radio: "1",
    };
  },
  mounted() {},
  methods: {
    artmag() {
      var that = this;

      that.$router.push({ name: "artmag", params: { refresh: true } });
    },
    goTome() {
      this.$router.push({ name: "me" });
    },
  },
};
</script>

<style>
.artshare_share_btn {
  background-image: url("../assets/yulan.png");
  width: 165px;
  height: 50px;
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
  margin-left: 15px;
  color: #fff6d5;
  border: none;
  cursor: pointer;
  font-size: 18px;
}

.artshare_btns_con {
  margin-top: 30px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.friend_name {
  margin-left: 14px;
  color: #333333;
  font-size: 18px;
}

.fri_img {
  width: 52px;
  height: 52px;
  border-radius: 50%;
}

.friend_item {
  padding-left: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  border-bottom: solid 1px #cccccc;
}

.artshare_con {
  margin-top: 30px;
  background-color: white;
}

.me_msg_btn {
  color: #2683be;
  font-size: 16px;
  margin-left: 15px;
  font-weight: 550;
  cursor: pointer;
}

.artshare_sear_ops_con {
  display: flex;
  align-items: center;
}

.artshare_start_col_btn {
  background-image: url("../assets/btnbg.png");
  width: 99px;
  height: 30px;
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
  margin-left: 15px;
  color: white;
  border: none;
  cursor: pointer;
}

.friend_add_in {
  margin-left: 5px;
  background: none;
  font-size: 18px;
  border: none;
  outline: none;
}

.friend_add_in_con {
  display: flex;
  align-items: center;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 3px;
  padding-bottom: 3px;
  border: solid 2px #0187ea;
  background-color: #edf7f9;
  width: 450px;
}

.artshare_sear_con {
  display: flex;
  align-items: center;
}

.artshare_sear {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.artshare_tip_noac {
  color: #707070 !important;
}

.artshare_tip {
  font-size: 18px;
  color: #2683be;
  cursor: pointer;
}

.artshare_top_bar {
  display: flex;
  align-items: center;
}
</style>
